// extracted by mini-css-extract-plugin
module.exports =  {"frame":"_33974c2b58--frame--sTly1"};